export const PRODUCT_BADGES = [
  { code: 'NOVIDADE', label: 'Novidade' },
  { code: 'RECOMENDADO', label: 'Recomendado' },
  { code: 'FAVORITO', label: 'Favorito' },
  { code: 'VEGANO', label: 'Vegano' },
  { code: 'VEGETARIANO', label: 'Vegetariano' },
  { code: 'ZERO_LACTOSE', label: 'Zero Lactose' },
  { code: 'ZERO_ACUCAR', label: 'Zero Açúcar' },
  { code: 'ORGANICO', label: 'Orgânico' },
  { code: 'BEBIDA_GELADA', label: 'Bebida Gelada' },
  { code: 'BEBIDA_ALCOOLICA', label: 'Bebida Alcoólica' },
  { code: 'NATURAL', label: 'Natural' },
] as const;

export type ProductBadgeCode = typeof PRODUCT_BADGES[number]['code'];

export function normalizeProductBadges(value: unknown): ProductBadgeCode[] {
  if (!Array.isArray(value)) return [];
  const selected = new Set(value.filter((code): code is string => typeof code === 'string'));
  return PRODUCT_BADGES.filter(badge => selected.has(badge.code)).map(badge => badge.code);
}
